import type GesCloudOrgSettingsPage from "@ext/enterprise-cloud/types/GesCloudOrgSettingsPage";

export type GesCloudAnalyticsEvent =
	| { name: "catalog_created"; props: { catalog: string } }
	| { name: "catalog_opened"; props: { catalog: string } }
	| { name: "org_settings_tab_opened"; props: { tab: GesCloudOrgSettingsPage } };

export type GesCloudTrackedAnalyticsEvent = GesCloudAnalyticsEvent & { occurredAt: number };

export const ANALYTICS_FLUSH_DELAY_MS = 10_000;
export const ANALYTICS_MAX_BATCH_SIZE = 20;

export class GesCloudAnalytics {
	private _queue: GesCloudTrackedAnalyticsEvent[] = [];
	private _flushTimer: ReturnType<typeof setTimeout> | null = null;

	constructor(private readonly _send: (events: GesCloudTrackedAnalyticsEvent[]) => Promise<void>) {}

	track(event: GesCloudAnalyticsEvent): void {
		this._queue.push({ ...event, occurredAt: Date.now() });
		if (this._queue.length >= ANALYTICS_MAX_BATCH_SIZE) this.flush();
		else this._flushTimer ??= setTimeout(() => this.flush(), ANALYTICS_FLUSH_DELAY_MS);
	}

	flush(): void {
		if (this._flushTimer) clearTimeout(this._flushTimer);
		this._flushTimer = null;
		if (!this._queue.length) return;

		const events = this._queue;
		this._queue = [];
		// Analytics is best-effort: a lost batch must never surface to the user.
		this._send(events).catch(() => {});
	}
}
